/*global Modernizr, Splide */
/*jslint browser:true */

function ThemeSlideCurrentSlide(Splide) {
  'use strict';

  let currentSlide = false;

  function mount() {
    var splide_arrows = Splide.root.querySelector('.splide__arrows__inner');

    if(!splide_arrows) {
      splide_arrows = Splide.root.querySelector('.splide__arrows');
    }

    if(splide_arrows && !splide_arrows.hasAttribute('data-show-status')) {
      var prev_arrow = splide_arrows.querySelector('.splide__arrow--prev');

      currentSlide = document.createElement('div');

      currentSlide.setAttribute('aria-live', 'polite');
      currentSlide.setAttribute('aria-atomic', 'true');
      currentSlide.classList.add('slider-status');

      currentSlide.textContent = `${ Splide.index + 1 }/${ Splide.length }`;

      prev_arrow.after(currentSlide);
      Splide.on('moved', onMoved);
    }
  }

  function onMoved() {
    if(currentSlide) {
      currentSlide.textContent = `${ Splide.index + 1 }/${ Splide.length }`;
    }
  }

  function destroy() {
    if(currentSlide) {
      Splide.root.removeChild(currentSlide);
    }
  }

  return {
    mount,
    destroy,
  };
}

function ThemeSlideHideArrows(Splide) {
  'use strict';

  function mount() {
    Splide.on('mounted resize', () => {
      if(Splide.length <= Splide.options.perPage) {
        Splide.root.querySelector('.splide__arrows').classList.add('hidden');
      } else {
        Splide.root.querySelector('.splide__arrows').classList.remove('hidden');
      }
    });
  }

  return {
    mount
  };
}

function ThemeSlideDisableDrag(Splide) {
  'use strict';

  function mount() {
    if(Splide.length === 1) {
      Splide.options = {drag: false};
    }
  }

  return {
    mount
  };
}